import { useEffect } from "react";
import { isAuthenticated } from "services/Auth";
import { fetchCurrentUser } from "store/user/user-action";
import { useDispatch } from "react-redux";

export const useGetUserData = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    (async () => {
      const isAuth = await isAuthenticated();
      if (isAuth) {
        dispatch(fetchCurrentUser());
      }
    })();
  }, [dispatch]);
};
